module.exports = __webpack_public_path__ + "static/media/logo-YPL.70e2b523.png";